type SparkleEffectProps = {
  activeKey: number;
};

const SPARKLES = Array.from({ length: 14 }, (_, index) => index);

export function SparkleEffect({ activeKey }: SparkleEffectProps) {
  if (activeKey === 0) return null;

  return (
    <div key={activeKey} className="rr-sparkles" aria-hidden="true">
      {SPARKLES.map((sparkle) => (
        <span key={sparkle} />
      ))}
    </div>
  );
}
